import { render, staticRenderFns } from "./ActGeometry__legendContent.vue?vue&type=template&id=c5553774&scoped=true&"
import script from "./ActGeometry__legendContent.vue?vue&type=script&lang=js&"
export * from "./ActGeometry__legendContent.vue?vue&type=script&lang=js&"
import style0 from "./ActGeometry__legendContent.vue?vue&type=style&index=0&id=c5553774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5553774",
  null
  
)

export default component.exports